module.exports = __webpack_public_path__ + "img/download.d934d9cc.svg";